import { mutations } from "@/constants/state";

export default {
  [mutations.TEMPLATE_LOCATIONS_FETCH_TEMPLATES_MUTATION]: (state, payload) => {
    state.templates = payload;
  },
};
